import { createFeature, createReducer, on } from "@ngrx/store";
import { PaymentLink, PaymentLinkInformation } from "../../interfaces";
import * as paymentLinkActions from './payment-link.actions';

const initialState: PaymentLinkInformation = {
    paymentLink: {
        paymentLink: ''
    },
    paymentLinkError: false,
    loading: false
};

const fetchPaymentLinkAction: any =
    (state: PaymentLinkInformation) => ({ ...initialState, loading: true });

const fetchPaymentLinkSuccessAction: any =
    (state: PaymentLinkInformation, paymentLink: PaymentLink) => ({ ...state, paymentLink: { ...paymentLink }, paymentLinkError: false, loading: false });

const fetchPaymentLinkErrorAction: any =
    (state: PaymentLinkInformation) => ({ ...state, paymentLink: { ...initialState.paymentLink }, paymentLinkError: true, loading: false });

const paymentLinkReducer = createReducer(
    initialState,
    on(paymentLinkActions.fetchPaymentLinkAction, fetchPaymentLinkAction),
    on(paymentLinkActions.fetchPaymentLinkSuccessAction, fetchPaymentLinkSuccessAction),
    on(paymentLinkActions.fetchPaymentLinkErrorAction, fetchPaymentLinkErrorAction),
);

export const PaymentLinkFeature = createFeature({
    name: 'paymentLink',
    reducer: paymentLinkReducer
});